import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import omitProps from '../../../utils/omitProps';
import queryMetaHandler from '../../../utils/queryMetaHandler';

export const GetTicketNumberGroupQuery = gql`
  query GetTicketNumberGroup {
    all_ticket_numbers(assigned: unassigned) {
      summary {
        totalNumberTickets: total_number_tickets
        totalManHours: total_man_hours {
          to_string
        }
        districtTicketNumberGroup: district_ticket_number_group {
          district {
            id
            name
          }
          totalNumberTickets: total_number_tickets
          totalManHours: total_man_hours {
            to_string
          }
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const [summary] = querySelector(data, '$.all_ticket_numbers.summary', []);
  return {
    ...ownProps,
    data,
    summary,
  };
};

const queryGetTicketNumberGroupData = graphql(GetTicketNumberGroupQuery, {
  props: marshallData,
  options: { fetchPolicy: 'network-only' },
});

export const queryGetTicketNumberGroupGQL = compose(
  queryGetTicketNumberGroupData,
  queryMetaHandler,
  omitProps(['data']),
);
